import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { POS_DOWNLOADS, posDownloadUrl, posReleasesBaseUrl } from '../posReleases.js';

/** Public marketing page for unauthenticated visitors. */
export function LandingView() {
  const { t } = useTranslation();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'Orio';
    document.documentElement.style.colorScheme = 'light';
    return () => {
      document.title = prevTitle;
      document.documentElement.style.colorScheme = '';
    };
  }, []);

  const releasesBase = posReleasesBaseUrl();

  return (
    <div className="landing">
      <header className="landing-nav">
        <a href="/" className="landing-logo">
          Orio
        </a>
        <a href="/login" className="landing-nav-link">
          {t('landing.signIn')}
        </a>
      </header>

      <section className="landing-hero">
        <div className="landing-hero-art" aria-hidden="true">
          <svg viewBox="0 0 280 200" fill="none">
            <path
              d="M126 52c-4-10 6-14 1-24"
              stroke="#86868b"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M150 48c-3-9 7-12 2-22"
              stroke="#86868b"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <ellipse cx="148" cy="168" rx="56" ry="7" stroke="#1d1d1f" strokeWidth="1.5" />
            <path
              d="M110 84l8 68c6 12 54 12 60 0l8-68"
              fill="#f5f5f7"
              stroke="#1d1d1f"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
            <ellipse cx="148" cy="84" rx="38" ry="8" fill="#fff" stroke="#1d1d1f" strokeWidth="1.5" />
            <path
              d="M186 98c22 8 20 36-6 42"
              stroke="#1d1d1f"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <h1>Orio</h1>
        <p className="landing-lead">{t('landing.lead')}</p>
        {releasesBase && (
          <p className="landing-downloads">
            {POS_DOWNLOADS.map((item, i) => (
              <span key={item.id}>
                {i > 0 && <span className="landing-downloads-sep">·</span>}
                <a href={posDownloadUrl(item.file) ?? undefined}>
                  {t(`landing.downloads.${item.id}`)}
                </a>
              </span>
            ))}
          </p>
        )}
        <a href="/login" className="landing-cta">
          {t('landing.signIn')}
        </a>
      </section>
    </div>
  );
}
